const queryParamsForMainLocation = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'yclid',
    'fbclid',
    'gclid',
    'gbraid',
    'wbraid',
];
const getMainLocationSearch = (url) => queryParamsForMainLocation
    .reduce((prev, param) => {
    const candidate = url.searchParams.get(param);
    if (candidate) {
        prev.append(param, candidate);
    }
    return prev;
}, new URLSearchParams())
    .toString();
const parseMainLocation = (urlString) => {
    try {
        const url = new URL(urlString);
        const search = getMainLocationSearch(url);
        return `${url.origin}${url.pathname}${search ? `?${search}` : ''}`;
    }
    catch (e) {
        console.error(e);
        return undefined;
    }
};

export { parseMainLocation };
//# sourceMappingURL=parseMainLocationUrl.js.map
